import {useTheme} from "@mui/material/styles"
import {AppBar, Stack, Toolbar, Typography} from "@mui/material"
import useResponsive from "../../../hooks/useResponsive"
import LanguagePopover from "../../dashboard/header/LanguagePopover"
import {HEADER} from "../../../config-global"
import {bgBlur} from "../../../utils/cssStyles"
import Logo from "../../../components/logo"
import {useSettingsContext} from "../../../components/settings"

export default function Header() {
    const {appName, companyName} = useSettingsContext()
    const theme = useTheme()
    const isDesktop = useResponsive("up", "lg")

    const renderContent = (
        <Stack
            flexGrow={1}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={{xs: 0.5, sm: 1.5}}
        >
            <Stack
                direction="row"
                spacing={2}
                sx={{mt: 2}}
            >
                <Logo sx={{mt: 1}}/>

                <Typography
                    variant="h6"
                    color={theme.palette.primary.main}
                >
                    {appName}<br/>{companyName}
                </Typography>
            </Stack>

            <Stack
                direction="row"
                spacing={2}
                sx={{paddingRight: 2}}
            >
                <LanguagePopover />
            </Stack>
        </Stack>
    )

    return (
        <AppBar
            sx={{
                boxShadow: "none",
                height: HEADER.H_MOBILE,
                zIndex: theme.zIndex.appBar + 1,
                ...bgBlur({
                    color: theme.palette.background.default
                }),
                transition: theme.transitions.create(["height"], {
                    duration: theme.transitions.duration.shorter
                }),
                ...(isDesktop && {
                    width: 1,
                    height: HEADER.H_DASHBOARD_DESKTOP,
                })
            }}
        >
            <Toolbar
                sx={{
                    height: 1,
                    paddingX: -8
                }}
            >
                {renderContent}
            </Toolbar>
        </AppBar>
    )
}